module.exports = __webpack_public_path__ + "static/media/just-cut.02ce0711.svg";